export const comments_5089936 = {"data":{"data":[],"links":{}}}